import React, {useContext} from "react";
import "./Skills.scss";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import {skillsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Skills() {
  const {isDark} = useContext(StyleContext);

  const resolveAsset = (m) =>
    m && typeof m === "object" && m.default ? m.default : m;

  const fallbackTrailer = require("../../assets/images/WebsiteTrailer.mp4");

  const media = skillsSection.media || {};
  const mediaSrc = resolveAsset(media.src) || resolveAsset(fallbackTrailer);

  const isVideo =
    typeof mediaSrc === "string" && /\.(mp4|webm|ogg)(\?.*)?$/i.test(mediaSrc);

  if (!skillsSection.display) {
    return null;
  }

  const rootClass = `${isDark ? "dark-mode main" : "main"} skills-section`;

  return (
    <div className={rootClass} id="skills">
      <div className="skills-main-div">
        <Fade left duration={1000}>
          <div className="skills-image-div">
            {/* Skills media (video or image) */}
            {mediaSrc ? (
              isVideo ? (
                <video
                  className="skills-bg-video"
                  autoPlay
                  loop
                  muted
                  playsInline
                  src={mediaSrc}
                />
              ) : (
                <img
                  className="skills-bg-video"
                  src={mediaSrc}
                  alt="Skills media"
                  loading="lazy"
                />
              )
            ) : null}
          </div>
        </Fade>

        <Fade right duration={1000}>
          <div className="skills-text-div">
            <h1 className={isDark ? "dark-mode skills-heading" : "skills-heading"}>
              {skillsSection.title}
            </h1>

            <p
              className={
                isDark
                  ? "dark-mode subTitle skills-text-subtitle"
                  : "subTitle skills-text-subtitle"
              }
            >
              {skillsSection.subTitle}
            </p>

            <SoftwareSkill />

            <div>
              {skillsSection.skills.map((skill, i) => (
                <p
                  key={i}
                  className={
                    isDark
                      ? "dark-mode subTitle skills-text"
                      : "subTitle skills-text"
                  }
                >
                  {skill}
                </p>
              ))}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}